module.exports = __webpack_public_path__ + "c85abe75b4f9e7c27bbf0042d3421ad5.svg";